import { render, staticRenderFns } from "./InvitationDecline.vue?vue&type=template&id=febca43e&scoped=true&"
import script from "./InvitationDecline.vue?vue&type=script&lang=ts&"
export * from "./InvitationDecline.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationDecline.vue?vue&type=style&index=0&id=febca43e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febca43e",
  null
  
)

export default component.exports